import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { PartnerClassificationReq } from '../model/classification';

@Injectable()
export class PartnerClassificationService {
    public partnerclassificationURL: string =
        environment.backend + environment.uri.partnerClassifications;
    constructor(private _http: HttpClient) {}

    getPartnerClassification(
        classificationRequestBody: PartnerClassificationReq
    ): Observable<any> {
        return this._http.post<any>(
            this.partnerclassificationURL,
            classificationRequestBody
        );
    }
}
